import { computed } from "vue";
import { useDisplay } from "vuetify";

// Single source of truth for the app's responsive breakpoints.
// isMobile drives the mobile nav, table→card transforms, and layout stacking.
// Threshold is smAndDown (<960px): phones and portrait tablets get the mobile
// treatment; landscape tablets and desktops keep the full layout.
export function useResponsive() {
  const display = useDisplay();
  return {
    display,
    isPhone: computed(() => display.xs.value), // <600
    isTablet: computed(() => display.sm.value), // 600–960
    isMobile: computed(() => display.smAndDown.value), // <960
    isDesktop: computed(() => display.mdAndUp.value), // >=960
  };
}
